import React from 'react';
import styles from './CommitmentsTableCommitment.module.scss';
import EastOutlinedIcon from '@mui/icons-material/EastOutlined';

export default function CommitmentsTableCommitment(props) {
  const { label, note, goal, isGoalAgnostic, startValue, endValue } = props;
  return (
    <div className={styles.commitmentsTableCommitment}>
      <div className={styles.details}>
        <p className={styles.label}>{label}</p>
        <p className={styles.note}>{note}</p>
        {(goal && (
          <p className={styles.goal}>
            Assigned to <span className={styles.goalLabel}>{goal}</span>
          </p>
        )) ||
          (isGoalAgnostic && (
            <p className={styles.goal}>
              <span className={styles.goalLabel}>Commitment is goal-agnostic</span>
            </p>
          )) || <p className={styles.goal}>Not assigned to a goal</p>}
      </div>
      <div className={styles.values}>
        <p>{startValue}</p>
        <span className={styles.icon}>
          <EastOutlinedIcon fontSize="inherit" />
        </span>
        <p>{endValue}</p>
      </div>
    </div>
  );
}
